import { render, staticRenderFns } from "./TheMemberActions.vue?vue&type=template&id=4c88cd2e&scoped=true&"
import script from "./TheMemberActions.vue?vue&type=script&lang=js&"
export * from "./TheMemberActions.vue?vue&type=script&lang=js&"
import style0 from "./TheMemberActions.vue?vue&type=style&index=0&id=4c88cd2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c88cd2e",
  null
  
)

export default component.exports